// frontend/src/pages/EsqueciSenhaPage/EsqueciSenhaPage.jsx

import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography, Result, message, Image } from 'antd';
import { UserOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate, Link } from 'react-router-dom';
import authService from '../../services/authService';
import logo from '../../assets/images/logo_vertical.jpg';
// 1. IMPORTAÇÃO DO TRATAMENTO DE ERRO
import { getErrorMessage } from '../../utils/errorHandler';
import '../../styles/auth.css';

const { Title } = Typography;

const EsqueciSenhaPage = () => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      await authService.solicitarResetSenha(values.email);
      setSuccess(true);
      // Removemos o message.success aqui para não ficar redundante com a tela de sucesso
    } catch (error) {
      console.error(error);
      // 2. USO NO ENVIO
      message.error(getErrorMessage(error, 'Erro ao solicitar recuperação. Verifique o e-mail digitado.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-shell">
      <Card className="auth-card">
        
        <Image
          width={180}
          src={logo}
          alt="Logo Saldo Ativo"
          preview={false}
          className="auth-logo"
        />

        {success ? (
          <Result
            status="success"
            title="E-mail Enviado!"
            subTitle={
              <span style={{ color: 'var(--color-text-secondary)' }}>
                Verifique sua caixa de entrada (e spam).<br/>
                Enviamos um link para você redefinir sua senha.
              </span>
            }
            extra={[
              <Button 
                type="primary" 
                key="console" 
                size="large" 
                block 
                onClick={() => navigate('/login')}
              >
                Voltar ao Login
              </Button>
            ]}
            style={{ padding: '0 0 24px 0' }}
          />
        ) : (
          <>
            <div style={{ marginBottom: 24 }}>
              <Title level={3} className="auth-title">
                Recuperar Senha
              </Title>
              <p className="auth-subtitle">
                Digite seu e-mail para receber o link.
              </p>
            </div>

            <Form
              name="forgot_password"
              onFinish={onFinish}
              size="large"
              autoComplete="off"
            >
              <Form.Item
                name="email"
                rules={[
                  { required: true, message: 'Por favor, insira seu e-mail!' },
                  { type: 'email', message: 'E-mail inválido!' }
                ]}
              >
                <Input prefix={<UserOutlined />} placeholder="Seu e-mail cadastrado" />
              </Form.Item>

              <Form.Item>
                <Button type="primary" htmlType="submit" block loading={loading}>
                  Enviar Link
                </Button>
              </Form.Item>

              <div style={{ textAlign: 'center', marginTop: 12 }}>
                <Link to="/login" style={{ color: 'var(--primary-color)' }}>
                  <ArrowLeftOutlined /> Voltar para o Login
                </Link>
              </div>
            </Form>
          </>
        )}
      </Card>
    </div>
  );
};

export default EsqueciSenhaPage;